var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2467_665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.125V1.875C11.25 1.25391 10.7461 0.75 10.125 0.75H1.875C1.25391 0.75 0.75 1.25391 0.75 1.875V10.125C0.75 10.7461 1.25391 11.25 1.875 11.25H10.125C10.7461 11.25 11.25 10.7461 11.25 10.125ZM3.375 4.5C3.16781 4.5 3 4.33219 3 4.125V3.375C3 3.16781 3.16781 3 3.375 3H6.375C6.58219 3 6.75 3.16781 6.75 3.375V4.125C6.75 4.33219 6.58219 4.5 6.375 4.5H3.375ZM3.375 6.75C3.16781 6.75 3 6.58219 3 6.375V5.625C3 5.41781 3.16781 5.25 3.375 5.25H8.625C8.83219 5.25 9 5.41781 9 5.625V6.375C9 6.58219 8.83219 6.75 8.625 6.75H3.375ZM3.375 9C3.16781 9 3 8.83219 3 8.625V7.875C3 7.66781 3.16781 7.5 3.375 7.5H4.875C5.08219 7.5 5.25 7.66781 5.25 7.875V8.625C5.25 8.83219 5.08219 9 4.875 9H3.375Z",
    fill: "#004967"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2467_665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.ba675dfa59b442e8b35e93d16f0dc190.svg";
export { ForwardRef as ReactComponent };